<template>
  <section id="sketch">
    <router-view />
  </section>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
